import { createFeatureSelector } from '@ngrx/store';
import { State } from './index';

export enum SortOrders {
  ASC = 'asc',
  DESC = 'desc',
}

export const defaultNormalRatePercentage = 100;
export const defaultOvertimeRatePercentage = 150;
export const defaultHolidayRatePercentage = 200;
export const defaultHolidayOvertimeRatePercentage = 300;

export const defaultItemsPerPage = 20;

export const getFeatureState = createFeatureSelector<State>('action-team');
